const transformToPoints = (points?: number, convertionValue?: number) => {
  if (points && convertionValue) {
    return points * convertionValue;
  }

  return 0;
};

export { transformToPoints };
